import React from "react";
import { Link } from "react-router-dom";
import { withRouter } from "react-router-dom";
import { Button, Modal } from "react-bootstrap";
// Redux
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { newsletterSubs } from "../../actions/newsletter";
import changePassword from "../../pages/changePassword";

class Footer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      email: "",
      msg: null,
      show: false,
      className: "",
      open: true,
    };
  }

  submitHandler = async (e) => {
    e.preventDefault();
    const res = await this.props.newsletterSubs({ email: this.state.email });
    console.log(res);
    if (res !== "Email Not Valid!") {
      this.setState({ msg: res, email: "", className: "text-success" });
      setTimeout(() => {
        this.setState({ msg: null });
      }, 5000);
    } else {
      this.setState({ msg: res, email: "", className: "text-danger" });
      setTimeout(() => {
        this.setState({ msg: null });
      }, 5000);
    }
  };
  _handleClose = () => {
    this.setState({ show: false });
  };
  _handleShow = () => {
    this.setState({ show: true });
  };
  _pushToMemberShip = () => {
    this.setState({ show: false });
    this.props.history.push("/membership-packages");
  };
  _pushToLogin = () => {
    this.setState({ show: false });
    this.props.history.push("/login");
  };
  chang = () => {
    this.setState({ open: false });
  };
  open1 = (check) => {
    return check ? (
      <button
        type="button"
        className="call-us-btn"
        onClick={(e) => this.chang()}
      >
        <span className="callTxt"> Call Us</span>
      </button>
    ) : (
      <button type="button" className="call-us-btn">
        <div className="callNmbr ">
          <span>
            <i className="fa fa-phone"></i>
          </span>
          &nbsp;
          <span>+1(888)969-0452</span>
        </div>
      </button>
    );
  };
  render() {
    const { isAuth } = this.props._auth;
    return (
      <div className="">
        <form onSubmit={this.submitHandler}>
          <div className="footer-form my-2">
            <div className="container">
              <div className="row">
                <div className="offset-md-2 col-md-4 py-md-3">
                  <p>Be the first to know about our daily sales!</p>
                </div>
                {/* <form onSubmit={this.submitHandler}> */}
                <div className="col-md-4 text-left py-md-3">
                  {this.state.msg && (
                    <div className={`  ${this.state.className}`}>
                      {this.state.msg}
                    </div>
                  )}
                  <label htmlFor="email" id="footer-input">
                    <input
                      type="email"
                      value={this.state.email}
                      placeholder="Email Address"
                      onChange={(e) => {
                        this.setState({ email: e.target.value });
                      }}
                      required
                    />

                    <button type="submit">Submit</button>
                  </label>
                </div>
                {/*          </form> */}
              </div>
            </div>
          </div>

          <footer className="footer wrapper-90 max-1600">
            <div className="container-fluid">
              <div className="row">
                <div className="col-md-4 text-center">
                  <div className="footer-about">
                    <h3>About Us</h3>
                    <ul>
                      <li>
                        <Link to="/about-us">About Sundial</Link>
                      </li>
                      <li>
                        <Link to="" onClick={this._handleShow}>
                          Sundial Membership
                        </Link>
                      </li>
                      <li>
                        <Link to="/register">Sell on Sundial</Link>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="col-md-4 text-center">
                  <div className="footer-customer-serivce">
                    <h3>Customer Service</h3>
                    <ul>
                      <li>
                        <Link to={"/my-orders"}>My Orders </Link>
                      </li>
                      <li>
                        <Link to={"/return-policy"}>Return Policy </Link>
                      </li>
                      <li>
                        <Link to={"/customer-service"}>Help Center</Link>
                      </li>
                      <li>
                        <Link to={"/customer-service"}>Report a bug</Link>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="col-md-4 text-center">
                  <div className="footer-contact">
                    <h3>Contact Us</h3>
                    <ul>
                      <Link to={"/customer-service"}>
                        <Button type="button" className="quick-service-btn">
                          Customer Service
                        </Button>
                      </Link>
                      <br />
                      {this.open1(this.state.open)}
                      {/*  <button type="button" className="call-us-btn">
                       <span className="callTxt"> Call Us</span>
                       <div className="callNmbr d-none">
                        <span><i className="fa fa-phone"></i></span>&nbsp;
                         <span>+1(888)969-0452</span>
                       </div>
                      </button> */}

                      <li>Mon - Fri: 8AM - midnight</li>
                      <li>Sat: 8AM - 8PM</li>
                      <li>Sun: 9AM - 6PM</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </footer>
          <div className="privaci-policy my-2">
            <div className="container">
              <div className="row" style={{ justifyContent: "center" }}>
                <div className="col-lg-10 col-md-8 col-sm-8 col-12 text-left py-md-5">
                  <p>
                    <Link to="/privacy-policy">privacy-policy</Link> |&nbsp;
                    <Link to="/term-conditions">
                      Terms &amp; Conditions
                    </Link>{" "}
                    |&nbsp;
                    <Link to="/disclaimer">Disclaimer</Link> |&nbsp;
                    <Link to="/cookie-policy">Cookie Policy</Link>
                  </p>
                </div>
                <div className="col-lg-2 col-md-4 col-sm-4 col-12 text-left py-md-5">
                  <div className="footer-icons">
                    <ul
                      className="footer-social-icons5"
                      style={{ display: "flex" }}
                    >
                      <li>
                        <a href="https://twitter.com/SundialHome">
                          <i
                            style={{ color: "#46d4fe" }}
                            className="fab fa-twitter"
                          />
                        </a>
                      </li>
                      <li>
                        <a href="https://www.facebook.com/SundialHP/">
                          <i
                            style={{ color: "#37589b" }}
                            className="fab fa-facebook-f"
                          />
                        </a>
                      </li>
                      <li className="insta">
                        <a href="https://www.instagram.com/sundial_home">
                          <i className="fab fa-instagram" />
                        </a>
                      </li>
                      <li>
                        <a href="https://www.pinterest.com/Sundial_HomeProducts/">
                          <i
                            style={{ color: "#cb2027" }}
                            className="fab fa-pinterest"
                          />
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Modal
            show={this.state.show}
            onHide={this.handleClose}
            animation={false}
            className="membership-class"
            style={{ marginTop: "2%", boxShadow: "none" }}
          >
            <Modal.Header closeButton onClick={this._handleClose}>
              <Modal.Title className="text-center">
                Sundial Loyalty Program{" "}
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div className="table-responsive">
                <div className="membership-pricing-table">
                  <table>
                    <tbody>
                      <tr>
                        <th className="plan-header plan-header-free">
                          <div className="pricing-plan-name">Memberships</div>
                          <div className="pricing-plan-period">
                            (points)0.05 = $ value of points collected
                          </div>
                        </th>
                        <th className="plan-header plan-header-free">
                          <div className="pricing-plan-name">
                            Sundial Free Membership
                          </div>
                          <div className="pricing-plan-price">
                            <sup>$</sup>00<span>.00</span>
                          </div>
                        </th>

                        <th className="plan-header plan-header-standard">
                          <div className="header-plan-inner">
                            {/*<span className="plan-head"> </span>*/}
                            <span className="recommended-plan-ribbon">
                              RECOMMENDED
                            </span>
                            <div className="pricing-plan-name">Sundial VIP</div>
                            <div className="pricing-plan-price">
                              <sup>$</sup>49<span>.99</span>
                            </div>
                            <div className="pricing-plan-period">year</div>
                          </div>
                        </th>
                      </tr>
                      <tr>
                        <td>
                          <b>Free delivery on transactions over $49</b>
                        </td>
                        <td>
                          <i className="fas fa-check-circle"></i>
                        </td>
                        <td>
                          <i className="fas fa-check-circle"></i>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <b>Free No-Rush Shipping</b>
                          (earn rewards for future purchases)
                        </td>
                        <td>
                          <i className="fas fa-check-circle"></i>
                        </td>
                        <td>
                          <i className="fas fa-check-circle"></i>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <b>
                            Collect reward points on your purchases Points Ratio
                          </b>{" "}
                          (n: n)
                        </td>
                        <td>1:1</td>
                        <td>1:2</td>
                      </tr>

                      <tr>
                        <td>
                          <b>Sundial Care Package</b>
                          We'll send you a surprise gift every quarter for free
                        </td>
                        <td>
                          <i className="fas fa-times-circle"></i>
                        </td>
                        <td>
                          <i className="fas fa-check-circle"></i>
                        </td>
                      </tr>
                      <tr>
                        <td />
                        <td>
                          <b>$0</b>
                        </td>
                        <td>
                          <b>$49.99 / Year</b>
                        </td>
                      </tr>
                      <tr>
                        <td />
                        <td />

                        <td>
                          {isAuth && !this.props._auth.loading ? (
                            <Link
                              onClick={this._pushToMemberShip}
                              className="text-center btn btn-primary"
                            >
                              Purchase
                            </Link>
                          ) : (
                            <Link
                              onClick={this._pushToLogin}
                              className="text-center btn btn-primary"
                            >
                              Sign Up
                            </Link>
                          )}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={this._handleClose}>
                Close
              </Button>
            </Modal.Footer>
          </Modal>
        </form>
      </div>
    );
  }
}

newsletterSubs.propTypes = {
  newsletterSubs: PropTypes.func.isRequired,
};
const mapStateToProps = (state) => ({
  _auth: state.auth,
});
export default connect(mapStateToProps, { newsletterSubs })(withRouter(Footer));
